
import React, { useContext, useEffect } from 'react';
import { ShopContext } from '../Context/ShopContext';
import { useNavigate } from 'react-router-dom';
import './Css/Success.css';

const Success = () => {
  const { clearCart } = useContext(ShopContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Clear the cart when arriving on this page
    clearCart();

    //  redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [clearCart, navigate]);

  return (
    <div className="success-container">
      <h1>🎉 Payment Successful!</h1>
      <p>Thank you for your purchase. Your order has been confirmed.</p>
      <p>You’ll be redirected to the home page shortly...</p>
    </div>
  );
};

export default Success;
